/*
 Created by qing on 2021/1/8
 Des:
 */

import BaseConfig from "../BaseConfig";
import {CONFIG_TYPE__CONTACT_ME} from "../type";

class ContactMe extends BaseConfig {
  constructor() {
    super()

    this.h = 10
    this.w = 15

    this.minW = 10
    this.maxW = 25
    this.minH = 8
    this.maxH = 15

    this.toEdit = false
  }

  get title() {
    return this.configName || ContactMe._title
  }

  set title(content) {
    this.configName = content
  }

}

ContactMe._title = ''
ContactMe.type = CONFIG_TYPE__CONTACT_ME

ContactMe.prototype.configType = ContactMe.type
ContactMe.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base
  }
}
ContactMe.prototype.setConf = function (opts) {
  this.setBase(opts)

  if (opts.hasOwnProperty('pH')) this.pH = opts.pH
  if (opts.hasOwnProperty('pW')) this.pW = opts.pW
  if (opts.hasOwnProperty('pX')) this.pX = opts.pX
  if (opts.hasOwnProperty('pY')) this.pY = opts.pY
}
ContactMe.prototype.getValue = function () {
}

export default ContactMe
